<template>
  <v-autocomplete
    class="field-custom"
    v-model="lang"
    :items="langList"
    :placeholder="placeholder"
    :item-value="itemValue"
    :item-text="itemText"
    :chips="chips"
    return-object
    outlined
    clearable
    dense
    hide-no-data
    hide-details="auto"
    :rules="rules"
  >
    <template v-slot:item="{ item }">
      {{ item.name }}
    </template>
    <template slot="no-data">
      <translate class="ml-3">No data available</translate>
    </template>
  </v-autocomplete>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    itemValue: {
      default: "id",
    },
    itemText: {
      default: "name",
    },
    placeholder: {
      default: "Choose language",
    },
    rules: {},
    value: {},
    chips: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lang: null,
      langList: [],
    };
  },
  computed: {
    ...mapState("location", {
      languages: "languages",
      countryLang: "countryLang",
    }),
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.lang = val;
      },
    },
    lang(val) {
      this.$emit("input", val);
    },
    languages: {
      immediate: true,
      handler(val) {
        let langs = [];
        if (val.length) langs = val;
        else langs = this.countryLang;

        if (this.lang) langs = [...langs, this.lang];

        this.langList = langs;
      },
    },
  },
};
</script>